// wrap a commonjs module and export it as a ESM module
import cjsModule from './index.js';
export default cjsModule;
